import { onWhiteboardPermissionsGrantedSaga } from 'features/permissions/sagas/onWhiteboardPermissionsGrantedSaga';
import { onWhiteboardPermissionsRevokedSaga } from 'features/permissions/sagas/onWhiteboardPermissionsRevokedSaga';
import { takeEvery, takeLatest } from 'redux-saga/effects';
import {
  allowBroadcast,
  allowEditWhiteboard,
  allowPresentContent,
  allowScreenshare,
  broadcastPermissionGranted,
  broadcastPermissionRevoked,
  bulkAllowBroadcast,
  bulkDisallowBroadcast,
  bulkAllowScreenshare,
  bulkDisallowScreenshare,
  bulkAllowEditWhiteboard,
  bulkDisallowEditWhiteboard,
  bulkAllowPresentContent,
  bulkDisallowPresentContent,
  changeRoleRequest,
  disallowBroadcast,
  disallowEditWhiteboard,
  disallowPresentContent,
  disallowScreenshare,
  managePrivateWhiteboardPermissionRevoked,
  signalingBroadcastAllowed,
  signalingBroadcastDisallowed,
  signalingEditWhiteboardAllowed,
  signalingEditWhiteboardDisallowed,
  signalingPresentContentAllowed,
  signalingPresentContentDisallowed,
  signalingRoleChanged,
  signalingScreenshareAllowed,
  signalingScreenshareDisallowed,
  whiteboardPermissionGranted,
  whiteboardPermissionRevoked,
} from 'features/permissions/actions';
import { bulkAllowBroadcastSaga } from 'features/permissions/sagas/bulkAllowBroadcastSaga';
import { bulkDisallowBroadcastSaga } from 'features/permissions/sagas/bulkDisallowBroadcastSaga';
import { allowBroadcastSaga } from 'features/permissions/sagas/allowBroadcastSaga';
import { disallowBroadcastSaga } from 'features/permissions/sagas/disallowBroadcastSaga';
import { onBroadcastAllowedSaga } from 'features/permissions/sagas/onBroadcastAllowedSaga';
import { onBroadcastDisallowedSaga } from 'features/permissions/sagas/onBroadcastDisallowedSaga';
import { allowScreenshareSaga } from 'features/permissions/sagas/allowScreenshareSaga';
import { disallowScreenshareSaga } from 'features/permissions/sagas/disallowScreenshareSaga';
import { onScreenshareAllowedSaga } from 'features/permissions/sagas/onScreenshareAllowedSaga';
import { onScreenshareDisallowedSaga } from 'features/permissions/sagas/onScreenshareDisallowedSaga';
import { bulkAllowScreenshareSaga } from 'features/permissions/sagas/bulkAllowScreenshareSaga';
import { bulkDisallowScreenshareSaga } from 'features/permissions/sagas/bulkDisallowScreenshareSaga';
import { changeRoleSaga } from 'features/permissions/sagas/changeRoleSaga';
import { onRoleChangedSaga } from 'features/permissions/sagas/onRoleChangedSaga';
import { onBroadcastPermissionGrantedSaga } from 'features/permissions/sagas/onBroadcastPermissionGrantedSaga';
import { onBroadcastPermissionRevokedSaga } from 'features/permissions/sagas/onBroadcastPermissionRevokedSaga';
import { allowEditWhiteboardSaga } from 'features/permissions/sagas/allowEditWhiteboardSaga';
import { disallowEditWhiteboardSaga } from 'features/permissions/sagas/disallowEditWhiteboardSaga';
import { bulkAllowEditWhiteboardSaga } from 'features/permissions/sagas/bulkAllowEditWhiteboardSaga';
import { bulkDisallowEditWhiteboardSaga } from 'features/permissions/sagas/bulkDisallowEditWhiteboardSaga';
import { onManagePrivateWhiteboardPermissionRevokedSaga } from 'features/permissions/sagas/onManagePrivateWhiteboardPermissionRevokedSaga';
import { onEditWhiteboardAllowedSaga } from 'features/permissions/sagas/onEditWhiteboardAllowedSaga';
import { onEditWhiteboardDisallowedSaga } from 'features/permissions/sagas/onEditWhiteboardDisallowedSaga';
import { allowPresentContentSaga } from 'features/permissions/sagas/allowPresentContentSaga';
import { disallowPresentContentSaga } from 'features/permissions/sagas/disallowPresentContentSaga';
import { bulkAllowPresentContentSaga } from 'features/permissions/sagas/bulkAllowPresentContentSaga';
import { bulkDisallowPresentContentSaga } from 'features/permissions/sagas/bulkDisallowPresentContentSaga';
import { onPresentContentAllowedSaga } from 'features/permissions/sagas/onPresentContentAllowedSaga';
import { onPresentContentDisallowedSaga } from 'features/permissions/sagas/onPresentContentDisallowedSaga';

export default function* permissionsWatcher() {
  yield takeLatest(broadcastPermissionGranted, onBroadcastPermissionGrantedSaga);
  yield takeLatest(broadcastPermissionRevoked, onBroadcastPermissionRevokedSaga);

  yield takeEvery(allowBroadcast, allowBroadcastSaga);
  yield takeEvery(disallowBroadcast, disallowBroadcastSaga);
  yield takeEvery(bulkAllowBroadcast, bulkAllowBroadcastSaga);
  yield takeEvery(bulkDisallowBroadcast, bulkDisallowBroadcastSaga);
  yield takeEvery(signalingBroadcastAllowed, onBroadcastAllowedSaga);
  yield takeEvery(signalingBroadcastDisallowed, onBroadcastDisallowedSaga);

  yield takeEvery(allowScreenshare, allowScreenshareSaga);
  yield takeEvery(disallowScreenshare, disallowScreenshareSaga);
  yield takeLatest(signalingScreenshareAllowed, onScreenshareAllowedSaga);
  yield takeLatest(signalingScreenshareDisallowed, onScreenshareDisallowedSaga);
  yield takeEvery(bulkAllowScreenshare, bulkAllowScreenshareSaga);
  yield takeEvery(bulkDisallowScreenshare, bulkDisallowScreenshareSaga);

  yield takeEvery(changeRoleRequest, changeRoleSaga);
  yield takeLatest(signalingRoleChanged, onRoleChangedSaga);

  yield takeLatest(whiteboardPermissionGranted, onWhiteboardPermissionsGrantedSaga);
  yield takeLatest(whiteboardPermissionRevoked, onWhiteboardPermissionsRevokedSaga);
  yield takeLatest(
    managePrivateWhiteboardPermissionRevoked,
    onManagePrivateWhiteboardPermissionRevokedSaga
  );

  yield takeEvery(allowEditWhiteboard, allowEditWhiteboardSaga);
  yield takeEvery(disallowEditWhiteboard, disallowEditWhiteboardSaga);
  yield takeEvery(bulkAllowEditWhiteboard, bulkAllowEditWhiteboardSaga);
  yield takeEvery(bulkDisallowEditWhiteboard, bulkDisallowEditWhiteboardSaga);

  yield takeEvery(signalingEditWhiteboardAllowed, onEditWhiteboardAllowedSaga);
  yield takeEvery(signalingEditWhiteboardDisallowed, onEditWhiteboardDisallowedSaga);

  yield takeEvery(allowPresentContent, allowPresentContentSaga);
  yield takeEvery(disallowPresentContent, disallowPresentContentSaga);
  yield takeEvery(bulkAllowPresentContent, bulkAllowPresentContentSaga);
  yield takeEvery(bulkDisallowPresentContent, bulkDisallowPresentContentSaga);

  yield takeEvery(signalingPresentContentAllowed, onPresentContentAllowedSaga);
  yield takeEvery(signalingPresentContentDisallowed, onPresentContentDisallowedSaga);
}
